module.exports = "/_next/static/images/Whenever@2x-06d20f12d3757b328b0111f4306785bd.webp";